export const PAGE_TYPES = {
  travels: 'travels',
  leisures: 'leisures',
  sport: 'sport',
  giftcards: 'giftcards'
};
